export const SET_ALL_EVENT_PLACES = (state, value) => {
  state.eventPlaces = value;
};

export const SET_NOMINATION_VALID = (state, value) => {
  state.nominationValid = value;
};
